import React from 'react';
import ReactApexChart from 'react-apexcharts';

type ChartProps = {
	// using `interface` is also ok
	[x: string]: any;
};
type ChartState = {
	chartData: any[];
	chartOptions: any;
};

class LineChart extends React.Component<ChartProps, ChartState> {
	constructor(props: { chartData: any[]; chartOptions: any }) {
		super(props);

		// react-apexcharts ignore les options mises à jour en même temps que la série : les données sont là dès le premier rendu
		this.state = {
			chartData: props.chartData,
			chartOptions: props.chartOptions
		};
	}

	render() {
		return (
			<ReactApexChart
				options={this.state.chartOptions}
				series={this.state.chartData}
				type='line'
				width='100%'
				height='100%'
			/>
		);
	}
}

export default LineChart;
